// extracted by mini-css-extract-plugin
module.exports = {"THEME_NAME":"\"fixtercore\"","page":"terms-conditions_page__V15PK"};